import script from "./forgot-password-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./forgot-password-page.vue?vue&type=script&setup=true&lang=ts"

import "./forgot-password-page.vue?vue&type=style&index=0&id=aa9094ba&lang=less"

const __exports__ = script;

export default __exports__